import { useContext } from "react";
import { AuthContext } from '../contexts/AuthContext';

export function useAuthentication() {
    const context = useContext(AuthContext);
    if (null === context) {
        throw new Error('useAuthentication() must be used inside a <Auth>');
    }
    return context;
}
